import './take-to-work-button.scss';

import { Alert } from 'antd';
import { useState } from 'react';

import { Button, Modal } from '@/components/Shared/ui';
import { autoCreditApi } from '@/integrations/app.api/auto-credit.api';
import { handleError } from '@/services/handleError';
import { getUserFullName } from '@/services/helpers/strings';
import { useAppDispatch, useAppSelector } from '@/store';
import { getRequestById } from '@/store/newOrder.slice';

const TakeToWorkButton: React.FC = () => {
  const dispatch = useAppDispatch();

  const {
    userAccesses: {
      autoCredit: { canTakeToWorkOnlineRequest }
    }
  } = useAppSelector((state) => state.userInfo);
  const { orderApp } = useAppSelector((state) => state.newOrder);

  const [isLoadingTakeToWork, setIsLoadingTakeToWork] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const takeToWork = async () => {
    if (
      !canTakeToWorkOnlineRequest ||
      !orderApp?.onlineClientRequest ||
      isError
    )
      return;

    try {
      setIsLoadingTakeToWork(true);
      await autoCreditApi.takeToWork(orderApp.onlineClientRequest.uuid);
      await dispatch(getRequestById({ reqId: orderApp.uuid }));
    } catch (error) {
      handleError(error, {
        onError: () => {
          setIsError(true);
        }
      });
    } finally {
      setIsModalOpen(false);
      setIsLoadingTakeToWork(false);
    }
  };

  return (
    <>
      <Alert
        type="info"
        title="Заявку необходимо взять в работу"
        className="take-to-work-button__alert"
        action={
          <Button
            onClick={() => setIsModalOpen(true)}
            size="small"
            variant="filled-blue"
            className="take-to-work-button__alert-button"
            disabled={isError}
          >
            Взять в работу
          </Button>
        }
      />
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Внимание"
        closable={!isLoadingTakeToWork}
        mask={{ closable: !isLoadingTakeToWork }}
      >
        <p>Подтверждаете, что данный клиент закреплён за вами?</p>
        <div className="take-to-work-button__client-info">
          <p className="take-to-work-button__client-info-label">ФИО:</p>
          <span className="take-to-work-button__client-info-value">
            {getUserFullName(orderApp?.personalInfo || {})}
          </span>
        </div>
        <div className="take-to-work-button__client-info">
          <p className="take-to-work-button__client-info-label">ИИН:</p>
          <span className="take-to-work-button__client-info-value">
            {orderApp?.personalInfo.clientIin}
          </span>
        </div>
        <div className="take-to-work-button__actions">
          <Button
            type="button"
            onClick={() => setIsModalOpen(false)}
            disabled={isLoadingTakeToWork}
          >
            Отмена
          </Button>
          <Button
            type="button"
            variant="filled-red"
            onClick={takeToWork}
            isLoading={isLoadingTakeToWork}
            disabled={isError}
          >
            Да, взять в работу
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default TakeToWorkButton;
